// In-app links to the user guides. The SPA and the docs site live on different
// origins, so these point at the guides on GitHub (#154).
export const ENABLE_BANKING_GUIDE_URL = 'https://github.com/danielvsantos/bliss/blob/main/docs/guides/enable-banking.md';
export const PLAID_GUIDE_URL = 'https://github.com/danielvsantos/bliss/blob/main/docs/guides/plaid-bank-sync.md';
